module.exports = __webpack_public_path__ + "static/images/alert.48767912734b306fd344205c02368efc.svg";